/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { useAuthorUrlGenerator } from '../../hooks/useUrlGenerator';
// import { FormattedMessage } from 'react-intl';
// import useFontSize from '../../hooks/useFontSize';
import * as AppPropTypes from '../../lib/PropTypes';
import camelCase from 'lodash/camelCase';

import DocumentsList from '../lists/DocumentsList';
import AuthorSummary from '../summaries/AuthorSummary';

import styles from '../../styles/cards/author-documents-card.module.css';

const propTypes = {
    id: PropTypes.string,
    slug: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    linkQuery: PropTypes.object,
    name: PropTypes.string,
    description: PropTypes.string,
    image: AppPropTypes.image,
    theme: PropTypes.oneOf([null, 'menu']),
    size: AppPropTypes.cardSize,
    ratio: PropTypes.oneOf(['square', 'square_double']),
    listTitle: PropTypes.node,
    // eslint-disable-next-line react/forbid-prop-types
    listProps: PropTypes.object,
    listCount: PropTypes.number,
    placeholder: PropTypes.bool,
    withoutText: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    id: null,
    slug: null,
    linkQuery: null,
    name: null,
    description: null,
    image: null,
    theme: null,
    size: null,
    ratio: null,
    listTitle: null,
    listProps: null,
    listCount: 3,
    placeholder: false,
    withoutText: false,
    className: null,
};

function AuthorDocumentsCard({
    id,
    slug,
    linkQuery,
    name,
    description,
    image,
    theme,
    size,
    ratio,
    listTitle,
    listProps,
    listCount,
    placeholder,
    withoutText,
    className,
}) {
    const url = useAuthorUrlGenerator();
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.withoutText]: withoutText,
                },
                styles[camelCase(size)],
                styles[camelCase(theme)],
                styles[camelCase(ratio)],
                className,
            ])}
        >
            <AuthorSummary
                slug={slug}
                name={name}
                description={description}
                image={image}
                imagePosition="left"
                className={styles.summary}
                innerClassName={styles.summaryInner}
                imageClassName={styles.summaryImage}
                descriptionClassName={styles.summaryDescription}
                placeholder={placeholder}
                withLink
                link={
                    url(
                        {
                            slug,
                        },
                        linkQuery,
                    ) || '#'
                }
            />
            {listTitle !== null ? <div className={styles.title}>{listTitle}</div> : null}
            <DocumentsList
                query={
                    !placeholder
                        ? {
                              author: id,
                          }
                        : null
                }
                disabled={placeholder}
                cardType="horizontal"
                cardRatio={ratio}
                cardSize={size}
                cardTheme={theme}
                count={listCount}
                columns={1}
                placeholder={placeholder}
                className={styles.list}
                {...listProps}
            />
        </div>
    );
}

AuthorDocumentsCard.propTypes = propTypes;
AuthorDocumentsCard.defaultProps = defaultProps;

export default AuthorDocumentsCard;
